/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Sub_Quickstart_DescriptionInputs */



/**
* | output |
* | --- |
* | "Send your first request: copy, paste, replace the key." |
*
* @param {Gateway_Sub_Quickstart_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_quickstart_description = /** @type {((inputs?: Gateway_Sub_Quickstart_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Quickstart_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Senden Sie Ihre erste Anfrage: kopieren, einfügen, Schlüssel ersetzen.")
	return /** @type {LocalizedString} */ ("Send your first request: copy, paste, replace the key.")
});